/*export class Accessorio {
    public Descrizione: string;
    public Prezzo: number;
    public Qta: number;
    constructor() {
        this.Descrizione = '';
        this.Prezzo = 0;
        this.Qta = 0;
    }
}
*/
export class Resource {
    id: number;
    descrIt: string;
    descrEn: string;
    descrDe: string;
    disp: number;
    qty: number;
    price: number;

    public Resource()
    {
        this.id = 0;
        this.descrIt = '';
        this.descrEn = '';
        this.descrDe = '';
        this.disp = 0;
        this.qty = 0;
        this.price = 0;
    }
}

export class AccessorioInfo {
    descrIt: string;
    descrEn: string;
    descrDe: string;
    variantiIt: string; // Menu Carne,Pesce
    variantiEn: string;
    variantiDe: string;
    prezzo: number; // varianti: primo 0 successivi -> prezzo
    type: number;   
    // 0 --> Seleziona...
    // 1 --> per ogni persona
    // 2 --> per quantità scelta dal cliente
    // 3 --> divisorio
    // 11 --> per ogni genitore (app == ludoteca)
    resourseIds: number[];
    resources: Resource[];

    // variabili di supporto
    qta: number;
    value: number;
    textValue: string;
    isObb: boolean;
    visibility: string;
    max: number;  // se è 0 vuol dire che prende il numero di partecipanti

    index: number; // indice della selezione corrente

    constructor() {
        this.descrIt = '';
        this.descrEn = '';
        this.descrDe = '';
        this.variantiIt = '';
        this.variantiEn = '';
        this.variantiDe = '';
        this.prezzo = 0;
        this.type = 0;

        this.qta = 0;
        this.value = 0;
        this.textValue = '';

        this.isObb = false;
        this.visibility = '';
        this.max = 0;

        this.resourseIds = [];
        this.resources = [];
        this.index = 0;
    }
}